export const getCMS = async (pageName) => {
  const formData = new FormData();
  formData.append("page_name", pageName);

  const response = await fetch(
    "https://idealtechnoride.in/api/cms",
    {
      method: "POST",
      body: formData,
    }
  );

  return await response.json();
};